export default "__VITE_ASSET__Ws$cpJ4J__"